import type { FC, SVGProps } from 'react';

export const RussiaIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg viewBox="0 0 24 16" width="24" height="16" aria-hidden {...props}>
    <rect width="24" height="16" rx="2" fill="#fff" />
    <rect y="5.33" width="24" height="5.34" fill="#0039a6" />
    <rect y="10.67" width="24" height="5.33" fill="#d52b1e" />
  </svg>
);

const starPoints = (
  cx: number,
  cy: number,
  outer: number,
  inner: number,
): string => {
  const points: string[] = [];

  for (let index = 0; index < 10; index += 1) {
    const radius = index % 2 === 0 ? outer : inner;
    const angle = -Math.PI / 2 + (index * Math.PI) / 5;

    points.push(
      `${cx + Math.cos(angle) * radius},${cy + Math.sin(angle) * radius}`,
    );
  }

  return points.join(' ');
};

const EU_STARS = Array.from({ length: 12 }, (_, index) => {
  const angle = (index / 12) * Math.PI * 2 - Math.PI / 2;

  return starPoints(
    30 + Math.cos(angle) * 9,
    20 + Math.sin(angle) * 6,
    1.15,
    0.48,
  );
});

/** European Union flag — EU, EEA, and EFTA marker. */
export const EuIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg viewBox="0 0 60 40" width="24" height="16" aria-hidden {...props}>
    <rect width="60" height="40" rx="4" fill="#003399" />
    {EU_STARS.map((points) => (
      <polygon key={points} fill="#fc0" points={points} />
    ))}
  </svg>
);

/** Union Jack — used as English locale marker. */
export const UkIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg viewBox="0 0 24 16" width="24" height="16" aria-hidden {...props}>
    <rect width="24" height="16" rx="2" fill="#012169" />
    <path d="M0 0 L24 16 M24 0 L0 16" stroke="#fff" strokeWidth="3.2" />
    <path d="M0 0 L24 16 M24 0 L0 16" stroke="#C8102E" strokeWidth="1.6" />
    <path d="M12 0 V16 M0 8 H24" stroke="#fff" strokeWidth="5" />
    <path d="M12 0 V16 M0 8 H24" stroke="#C8102E" strokeWidth="2.6" />
  </svg>
);
